import { Provider } from "react-redux";
import { store } from "./Redux/store/store";
import { makeStyles, ThemeProvider } from "@material-ui/core/styles";
import { custom_theme } from "./theme";
import AppRoutes from "./Routes/AppRoutes";

const useGlobalStyles = makeStyles({
  "@global": {
    body: {
      margin: "0",
      padding: "0",
      height: "100vh"
    },
    html:{
      scrollBehavior: 'smooth'
    }
  },
});

function MyThemProvider({ children }) {
  useGlobalStyles();
  return <ThemeProvider theme={custom_theme}>{children}</ThemeProvider>;
}

function App() {
  return (
    <MyThemProvider>
      <Provider store={store}>
        <AppRoutes/>
      </Provider>
    </MyThemProvider>
  );
}

export default App;
